import React from 'react';
import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import './assets/custom.css';
import './assets/tailwind-compiled.css';
import 'react-datepicker/dist/react-datepicker.css';
import { FocusContextProvider } from './contexts/focusContext';
import App from './App';
import * as serviceWorker from './serviceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));
const container = document.getElementById('root');
// const root = createRoot(container);

ReactDOM.render(
  <React.StrictMode>
    <FocusContextProvider>
      <App />
    </FocusContextProvider>
  </React.StrictMode>,
  // document.getElementById('root')
  container
);
// root.render(
//   <React.StrictMode>
//     <FocusContextProvider>
//       <App />
//     </FocusContextProvider>
//   </React.StrictMode>
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
